import styled from 'styled-components';

const Detalle = styled.div`
  .row-detalle {
    display: flex;
    align-items: center;
  }

  .row-detalle span {
    width: 150px;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
  }
  .row-detalle .strong{
    font-weight: bold;
  }
  .row-detalle p {
    font-size: 14px;
    color: #333333;
    font-weight: 500;
  }
  .separador-comprobante {
    margin-bottom: 15px;
  }
`;

export default Detalle;
